module.exports = __webpack_public_path__ + "img/reserved_2.da237db9.jpg";